import React, {useState, useEffect} from 'react'
import { ListGroup, ListGroupItem, Badge, Pagination, PaginationItem, PaginationLink, Input } from 'reactstrap';
import { Link } from "react-router-dom";

//Componentes
import AssignButton from '../buttons/AssignButton';
import GrupoAPEButton from '../buttons/GrupoAPEButton';
import OnHoldAPEButton from '../buttons/OnHoldAPEButton';

const ListadoV2 = (props) => {
    const itemsPerPage = 100
    const [page, setPage] = useState(0);
    const [arrayToShow, setArrayToShow] = useState([]);
    const [pages, setPages] = useState([]);
    const procesoHabAux = ['reclutamiento', 'contratacion'];

    useEffect(() => {
        divideArr()
    }, [page, props])

    const divideArr = () => {
        const numPages = [...Array(props.listaSolicitudes.length % itemsPerPage === 0 ? parseInt(props.listaSolicitudes.length / itemsPerPage) : parseInt(props.listaSolicitudes.length / itemsPerPage) + 1).keys()];
        const newArr = props.listaSolicitudes.slice(page * itemsPerPage, (page * itemsPerPage) + itemsPerPage);
        setArrayToShow(newArr);
        setPages(numPages);
    }

    if (props.listaSolicitudes.length > 0) {
        return (
            <>
                <ListGroup>
                    {
                        arrayToShow.map((solicitud, index) => {
                            return (
                                <div key={`divG_reclutamiento_${index}`} className='reclutamiento-list-item'>
                                    <ListGroupItem key={`lisItem_reclutamiento_${index}`} color={solicitud.color} style={{ paddingLeft: '30px' }}>
                                        <div key={`div_reclutamiento_${index}`} className='reporte-list-area'>
                                            <Input
                                                key={`key_checkbox2_${index}`}
                                                id={`checkbox2_${index}`}
                                                type="checkbox"
                                                onChange={(e) => props.handleCheck({ value: e.target.checked, field: solicitud.cedula })}
                                            />
                                            {`${solicitud.cedula} - ${solicitud.nombre}`}
                                        </div>
                                    </ListGroupItem>
                                </div>)
                        })
                    }
                </ListGroup>
                <div className='ape-list-pagination'>
                    <Pagination size="sm"
                    >
                        {/* <PaginationItem disabled={page === 0}>
                        <PaginationLink
                            onClick={() => setPage(0)}
                            first
                        />
                    </PaginationItem> */}
                        <PaginationItem disabled={page === 0}>
                            <PaginationLink
                                onClick={() => setPage(page > 0 ? page - 1 : 0)}
                                previous
                            />
                        </PaginationItem>
                        {pages.map(pageInd => {
                            return (
                                <PaginationItem>
                                    <PaginationLink onClick={() => setPage(page)}>
                                        {pageInd + 1}
                                    </PaginationLink>
                                </PaginationItem>
                            )
                        })}
                        <PaginationItem disabled={page === pages.length - 1}>
                            <PaginationLink
                                next
                                onClick={() => setPage(page < pages.length - 1 ? page + 1 : pages.length - 1)}
                            />
                        </PaginationItem>
                        {/* <PaginationItem disabled={page === pages.length - 1}>
                        <PaginationLink
                            last
                            onClick={() => setPage(pages.length - 1)}
                        />
                    </PaginationItem> */}
                    </Pagination>
                </div>
            </>
        );
    }
    else {
        return <div className='ape-list-nodata-text'>
            <p>No hay reportes</p>
        </div>
    }
}

export default ListadoV2